import $ from "jquery";
import { EventBus } from "./services/event-bus.js";

export const validationMessages = {
  valueMissing: (label) => `${label} is required`,
  tooLong: (label) => `${label} is too long`,
  rangeOverflow: (label, max) =>
    `${label} must be less than or equal to ${max}`,
  tooShort: (label) => `${label} is too short`,
  rangeUnderflow: (label, min) =>
    `${label} must be greater than or equal to ${min}`,
  patternMismatch: (label) => `${label} must be valid`,
  badInput: (label) => `${label} has incorrect value`,
  stepMismatch: (label) => `${label} has a step mismatch`,
  typeMismatch: (label) => `${label} is not in the correct syntax`,
  unknown: (label) => ``,
};

export function handleFormValidation(
  form,
  validationMessages,
  isTextAreaValidation
) {
  form[0].classList.add("ms-was-validated");

  form.find("input, select, textarea").each(function () {
    let element = $(this);
      let label = "";
      if (element.closest("fieldset").length > 0) {
        label = element.closest("fieldset").find("legend").text().trim();
      } else {
        label = element
          .closest(".mfc-form-input-container")
          .find("label")
          .text()
          .trim();
      }

      element.on("input", function () {
        let errorMessage = getErrorMessage(element[0], label);
        displayFormErrorMessage(element, errorMessage);
      });

      if (!element[0].checkValidity()) {
        let errorMessage = getErrorMessage(element[0], label);
        displayFormErrorMessage(element, errorMessage);
      }
  
  });
}

function getErrorMessage(element, label) {
  if (element.validity.valueMissing) {
    return validationMessages.valueMissing(label);
  } else if (element.validity.badInput) {
    return validationMessages.badInput(label, element.type);
  } else if (element.validity.patternMismatch) {
    return validationMessages.patternMismatch(label);
  } else if (element.validity.rangeOverflow) {
    return validationMessages.rangeOverflow(label, element.max);
  } else if (element.validity.rangeUnderflow) {
    return validationMessages.rangeUnderflow(label, element.min);
  } else if (element.validity.stepMismatch) {
    return validationMessages.stepMismatch(label);
  } else if (element.validity.tooLong) {
    return validationMessages.tooLong(label);
  } else if (element.validity.tooShort) {
    return validationMessages.tooShort(label);
  } else if (element.validity.typeMismatch) {
    return validationMessages.typeMismatch(label, element.type);
  } else {
    return validationMessages.unknown(label);
  }
}

export function displayErrorMessage(element, message) {
  if(message == "Tags must be valid")
    {
      let label =  element
      .closest(".mfc-form-input-container")
      .find("label");
      message = label.text().trim() + ' must be valid'
    }
  let feedback = element
    .closest(".mfc-form-input-container")
    .find(".mfc-invalid-feedback");
  if (feedback.length === 0) {
    feedback = $('<div class="mfc-invalid-feedback"></div>').appendTo(
      element.closest(".mfc-form-input-container")
    );
  }
  feedback.empty();

  let errorMessageSpan = $("<span></span>").text(message).appendTo(feedback);
}

export function displayFormErrorMessage(element, message) {
  let feedback = element
    .closest(".mfc-form-input-container")
    .find(".mfc-invalid-feedback");
  if (feedback.length === 0) {
    feedback = $('<div class="mfc-invalid-feedback"></div>').appendTo(
      element.closest(".mfc-form-input-container")
    );
  }
  feedback.empty();

  let errorMessageSpan = $("<span></span>").text(message).appendTo(feedback);
}

export function checkValidDateRange(dateFrom, dateTo) {
  if (
    new Date(dateTo).setHours(0, 0, 0, 0) <
    new Date(dateFrom).setHours(0, 0, 0, 0)
  ) {
    const notification = {};
    notification.msg = "Date To must not be before Date From";
    EventBus.$emit("error-notification", notification);
    return false;
  }
  return true;
}

export function checkFormAndTextareaValidations(textareaId, pattern, form) {
  const textarea = document.getElementById(textareaId);
  let textareaValidated = false;
  let isFormInvalid = false;
  if (!form[0].checkValidity()) {
    handleFormValidation(form, validationMessages, true);
    isFormInvalid = true;
  }
  if (textarea) {
    const validateTextarea = () => {
      if (!form[0].checkValidity()) {
        isFormInvalid = true;
      }else
      {
        isFormInvalid = false;
      }
      if (!textarea.validity.valid) {
        return false;
      } else {
        const value = textarea.value;
        if (pattern && !new RegExp(pattern).test(value)) {
          const nearbyLabel = findNearbyLabel(textarea);
          const label = nearbyLabel
            ? nearbyLabel.innerText.trim()
            : "This field";
          const invalidText = `${label} must be valid`;
          textarea.classList.add("ms-is-invalid");
          displayTextAreaMessage(textarea, invalidText);

          textareaValidated = true;
          return false;
        } else {
          textarea.classList.remove("ms-is-invalid");
          textarea.setCustomValidity("");
          if (isFormInvalid) return false;
        }
        return true;
      }
    };
    if (!textareaValidated)
      textarea.addEventListener("input", validateTextarea);

    return validateTextarea();
  }
  return true;
}
function displayTextAreaMessage(textarea, invalidText) {
  const container = textarea.closest(".mfc-form-input-container");
  let feedback = container
    ? container.querySelector(".mfc-invalid-feedback")
    : null;
  if (!feedback) {
    feedback = document.createElement("div");
    feedback.classList.add("mfc-invalid-feedback");
    container.appendChild(feedback);
  }
  feedback.textContent = invalidText;
}

function findNearbyLabel(element) {
  let label = element.previousElementSibling;
  while (label) {
    if (label.tagName.toLowerCase() === "label") {
      return label;
    }
    label = label.previousElementSibling;
  }
  return null;
}
